import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { I18nProvider } from './i18n/I18nProvider';
import { ThemeProvider } from './theme/ThemeProvider';
import { RequireAuth, HomeRedirect, OwnerOnly, CompanyOnly, LegacyRedirect, LEGACY_PATHS } from './session/guards';
import OwnerLayout from './layouts/OwnerLayout';
import CompanyLayout from './layouts/CompanyLayout';

import LoginPage from './pages/LoginPage';
import AuditPage from './pages/shared/AuditPage';
import TeamPage from './pages/company/TeamPage';
import OverviewPage from './pages/owner/OverviewPage';
import CompaniesPage from './pages/owner/CompaniesPage';
import CompanyDetailPage from './pages/owner/company/CompanyDetailPage';
import BillingPage from './pages/owner/BillingPage';
import BillingRemindersPage from './pages/owner/BillingRemindersPage';
import LogsPage from './pages/owner/LogsPage';
import SecurityPage from './pages/owner/SecurityPage';
import SqlConsolePage from './pages/owner/SqlConsolePage';
import SystemSettingsPage from './pages/owner/SystemSettingsPage';
import SupportPage from './pages/owner/SupportPage';
import EmployeesPage from './features/employees/EmployeesPage';
import AnalyticsPage from './features/analytics/AnalyticsPage';
import NotificationsPage from './features/notifications/NotificationsPage';
import HomePage from './pages/company/HomePage';
import VenuesPage from './pages/company/VenuesPage';
import BrandingPage from './pages/company/BrandingPage';
import MyCompanyPage from './pages/company/MyCompanyPage';


function App() {
  return (
    <I18nProvider>
      <ThemeProvider>
        <Router>
          <Toaster
            position="top-right"
            toastOptions={{
              className: '!text-sm !rounded-xl !shadow-pop dark:!bg-zinc-800 dark:!text-zinc-100',
            }}
          />
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route element={<RequireAuth />}>
              <Route path="/" element={<HomeRedirect />} />

              {/* Консоль владельца платформы */}
              <Route path="/owner" element={<OwnerOnly><OwnerLayout /></OwnerOnly>}>
                <Route index element={<OverviewPage />} />
                <Route path="companies" element={<CompaniesPage />} />
                <Route path="companies/:id" element={<CompanyDetailPage />} />
                <Route path="billing" element={<BillingPage />} />
                <Route path="billing/reminders" element={<BillingRemindersPage />} />
                <Route path="employees" element={<EmployeesPage />} />
                <Route path="analytics" element={<AnalyticsPage />} />
                <Route path="notifications" element={<NotificationsPage />} />
                <Route path="support" element={<SupportPage />} />
                <Route path="audit" element={<AuditPage />} />
                <Route path="logs" element={<LogsPage />} />
                <Route path="security" element={<SecurityPage />} />
                <Route path="sql" element={<SqlConsolePage />} />
                <Route path="settings" element={<SystemSettingsPage />} />
              </Route>

              {/* Кабинет компании */}
              <Route path="/company" element={<CompanyOnly><CompanyLayout /></CompanyOnly>}>
                <Route index element={<HomePage />} />
                <Route path="employees" element={<EmployeesPage />} />
                <Route path="analytics" element={<AnalyticsPage />} />
                <Route path="notifications" element={<NotificationsPage />} />
                <Route path="venues" element={<VenuesPage />} />
                <Route path="branding" element={<BrandingPage />} />
                <Route path="profile" element={<MyCompanyPage />} />
                <Route path="team" element={<TeamPage />} />
                <Route path="audit" element={<AuditPage />} />
              </Route>

              {LEGACY_PATHS.map((p) => (
                <Route key={p} path={`/${p}`} element={<LegacyRedirect from={p} />} />
              ))}
              <Route path="*" element={<HomeRedirect />} />
            </Route>
          </Routes>
        </Router>
      </ThemeProvider>
    </I18nProvider>
  );
}

export default App;
